import styled from 'styled-components/macro';
import { animated } from 'react-spring'


export const Container = styled.div`
    display: flex;
    flex-direction: column;
    // background-color: #485461;
    // background-image: linear-gradient(315deg, #485461 0%, #28313b 74%);
    // background-color: #f6f6f6;
    height: 100vh;
    position: relative;
`;

export const CardsContainer = styled(animated.div)`
    overscroll-behavior-y: contain;
    margin: 0;
    padding: 0;
    user-select: none;
    // background-color: #485461;
    // background-image: linear-gradient(315deg, #485461 0%, #28313b 74%);
    // background-color: #f6f6f6;
    position: absolute;
    top: 20%;
    left: 0;
    overflow-x: hidden;
    width: 100%;
    height: 80%;
    cursor: url('https://uploads.codesandbox.io/uploads/user/b3e56831-8b98-4fee-b941-0e27f39883ab/Ad1_-cursor.png') 39 39, auto;
`;

export const CardDeck = styled(animated.div)`
    position: absolute;
    width: 100vw;
    height: 80vh;
    will-change: transform;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Card = styled(animated.div)`

`;